import React from "react";
import {Form} from 'react-bootstrap';

function STCFormCheckLabel(props){

    return(
        <Form.Check.Label
            style={props.style}
            className={props.className}

            htmlFor={props.htmlFor}
            bsPrefix={props.bsPrefix}
        >
            {props.children}
        </Form.Check.Label>
    )
}
export default STCFormCheckLabel;